module.exports = "@media (min-width: 767px) {\n  .animated-circle:after {\n    bottom: 200px;\n    left: 110px; } }\n"